<template>
  <div class="system-progress-bar" @mouseover="show_hints = true">
    <div class="title c-orange" v-if="isSuspeneded">
      {{ $t("system_progress_bar.suspended") }}
    </div>
    <div class="title" v-else-if="!isActive">
      {{ $t("system_progress_bar.not_active") }}
    </div>
    <div class="title c-green" v-else>
      {{ $t("system_progress_bar.active") }}
    </div>
    <div class="progress-tabs">
      <div
        v-for="i in tabCount"
        :key="i"
        :style="{
          width: tabWidth,
        }"
        :class="{ 
          'progress-tab': true, 
          'active-tab': i - 1 < activeCount,
          'suspended-tab': isSuspeneded
        }"
      ></div>
    </div>
    <div
      v-if="show_hints"
      v-click-outside="hideHints"
      class="system-start-necessary-items"
    >
      <div class="items-header">
        {{ $t("system_progress_bar.needed") }}
      </div>
      <div class="items-container">
        <div
          v-for="(v, k) in filteredReady"
          :key="k"
          :class="{ item: true, 'active-item': !!v }"
          @click="goToSetting(k)"
        >
          <img
            :src="`/icons/check-list-icon-${!!v ? 'active' : 'disabled'}.svg`"
            alt=""
          />
          {{ $t(`mode_settings_hints.${k}`) }}
        </div>
      </div>
      <div class="comment">
        {{ $t("system_progress_bar.hint") }}
      </div>
    </div>
  </div>
</template>
<script>
import IQOS from "./IQOS.old.vue";
export default {
  components: {
    IQOS,
  },
  props: {
    ready: Object,
  },
  data() {
    return {
      show_hints: false,
      settings_routes: {
        address: "general",
        geolocation: "delivery",
        menu: "menus",
        notifications: "notifications",
        payment: null,
        schedule: "general",
        waiters: "workers",
        stickers: "stickers_gallery",
        tables: "halls",
        subscription: "systems"
      },
    };
  },
  methods: {
    goToSetting(s) {
      const route = this.settings_routes[s];

      if (route) this.$router.push({
        path: `/${route}`,
        query: {
          refsys: this.$route.name
        }
      });
    },
    hideHints() {
      this.show_hints = false;
    },
  },
  computed: {
    tabCount() {
      return Object.keys(this.ready).length;
    },
    tabWidth() {
      return `calc(${100 / this.tabCount}% - ${(1.1 * this.tabCount - 1) /
        this.tabCount}vh )`;
    },
    isActive() {
      return Object.values(this.ready).reduce((acc, item) => acc && item, true) && !this.isSuspeneded;
    },
    activeCount() {
      return Object.values(this.ready).reduce((acc, item) => acc + !!item, 0);
    },
    filteredReady() {
      const result = Object.assign({}, this.ready);

      if (result.subscription) delete result.subscription;

      return result;
    },
    isSuspeneded() {
      return !this.ready.subscription;
    }
  },
};
</script>
<style scoped>
.system-progress-bar {
  position: relative;
  top: 0;
  right: 0;
  min-width: 59.444vw;
  max-width: 59.444vw;
  margin-right: -3.333vh;
}
.title {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #908f8d;
}
.progress-tabs {
  display: flex;
  width: 100%;
}
.progress-tab {
  height: 0.3333333333333333vh;
  border-radius: 4.555555555555555vh;
  background: #908f8d;
  margin-right: 1.1111111111111112vh;
  cursor: pointer;
}
.progress-tab:last-child {
  margin-right: 0;
}
.active-tab {
  background: #129b81;
}
.system-start-necessary-items {
  width: 57.77vw;
  position: fixed;
  top: 10vh;
  z-index: 10;
  margin-right: 2.2222222222222223vh;
  background: #1d1d1bf5;
  backdrop-filter: blur(15px);
  padding: 3.3333333333333335vh;
  border-radius: 1.3333333333333333vh;
}
.items-header {
  font-size: 2.7777777777777777vh;
  line-height: 3.2222222222222223vh;
  color: #908f8d;
}
.items-container {
  margin: 3.3333333333333335vh 0;
}
.item {
  font-size: 2.2222222222222223vh;
  line-height: 2.5555555555555554vh;
  color: #908f8d;
  display: flex;
  align-items: center;
  margin-bottom: 3.3333333333333335vh;
  cursor: pointer;
}
.active-item {
  color: #ededed;
}
.item img {
  width: 2.6666666666666665vh;
  height: 2.6666666666666665vh;
  margin-right: 1.1111111111111112vh;
}
.comment {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
}
.suspended-tab {
  background: #f96d1e;
}
</style>
